<div class="container">

  <form [formGroup]="pelForm">

    <div class="row" *ngIf="isEdit">
      <h2 class="display-6" style="margin-bottom:0%">Gear Name</h2>
    </div>

    <div class="row" *ngIf="isEdit">
      <div class="col">
        <div class="row">
          <mat-form-field style="font-weight: bold;">
            <mat-label>Name</mat-label>
            <input matInput type="text" formControlName="name">
            <mat-hint>Leave blank to auto letter gear</mat-hint>
          </mat-form-field>
        </div>
      </div>
    </div>

    <br>
    <br>

    <div class="row">
      <h1 class="display-6" style="margin-bottom:0%">Other Hook & Line Gear Type</h1>
    </div>

    <div class="row">
      <mat-form-field>
        <mat-select formControlName="pelagicType" [compareWith]="compareFn" required>
          <mat-option *ngFor="let type of types" [value]="type">
            {{type}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="pelForm.invalid">Required</mat-error>
      </mat-form-field>
    </div>

    <br>

    <div class="row">
      <h1 class="display-6" style="margin-bottom:0%">Total Number of mainlines or rods</h1>
    </div>

    <div class="row">
      <mat-form-field>
        <input matInput type="text" inputmode="decimal" formControlName="totalRods" (input)="_forbidNonNumeric(pelForm.get('totalRods')!)" required>
        <mat-error *ngIf="pelForm.invalid">Required</mat-error>
      </mat-form-field>
    </div>

    <br>

    <div class="row">
      <h1 class="display-6" style="margin-bottom:0%">Number of hooks on each mainline or rod</h1>
    </div>

    <div class="row">
      <mat-form-field>
        <input matInput type="text" inputmode="numeric" formControlName="numHooksPerRod" (input)="_forbidNonNumeric(pelForm.get('numHooksPerRod')!)" required>
        <mat-error *ngIf="pelForm.invalid">Required</mat-error>
      </mat-form-field>
    </div>

    <div class="row">
      <h1 class="display-6">Non-trawl RCA Gear?</h1>
      <br>
      <mat-radio-group aria-label="Select an option" formControlName="isNTRCA">
        <mat-radio-button value="{{true}}">Yes</mat-radio-button>
        <mat-radio-button [checked]="!pelForm.get('isNTRCA')?.value" value="{{false}}" style="padding-left: 10px">No</mat-radio-button>
      </mat-radio-group>
    </div>

  </form>

  <!-- Cancel or create pelagic gear -->
  <div class="row justify-content-between" style="margin-top: 50px;" align="center">
      <button mat-stroked-button
              class="text-blue-button"
              type="button"
              aria-label="confirm"
              (click)="cancelEvent.emit('Pelagic')">        
        Cancel
      </button>

      <button mat-stroked-button
              class="text-button"
              type="submit"
              aria-label="confirm"
              (click)="onConfirmBtnClick()">
        OK
      </button>
  </div>

</div>
